import { Controller } from "@hotwired/stimulus"

/**
 * Grows a textarea to fit its content as the user types, instead of scrolling
 * inside a fixed-height box. Attach directly to the textarea:
 *
 * <textarea data-controller="textarea-autogrow"
 *           data-action="input->textarea-autogrow#resize"></textarea>
 */
export default class extends Controller {
  connect() {
    this.element.style.overflowY = "hidden"
    this.element.style.resize = "none"
    this.resize()
  }

  resize() {
    const el = this.element
    el.style.height = "auto"
    const borders = el.offsetHeight - el.clientHeight
    el.style.height = `${el.scrollHeight + borders}px`
  }
}
